Ext.define('SA.VectorMapViewController', {
    constructor({model, activeState}) {
        this.model = model;
        this.activeState = activeState;

        this.toolbar = new SA.view.MapToolbar({projectView: model});
        this.viewportsCache = new SA.RequestsCache(SA.VectorMapLocationViewportRequests);

        this.initEvents();
    },

    getView() {
        return this.projectView?.getItem();
    },

    initEvents() {
        this.activeState.onActive(this.onActive, this);
        this.activeState.onInactive(this.onInactive, this);

        this.model.on('change:location', this.loadLocationViewport, this);
        this.model.on('remove', this.onModelRemove, this);

        new SA.VectorMapLocationValidator({model: this.model, activeState: this.activeState});
        new SA.VectorMapModelStateObserver({model: this.model, handler: this.refresh, scope: this});

        this.toolbar.on('change:attribute', this.onAttributeComboChange, this);
        this.toolbar.on('change:location', this.onLocationDropdownChange, this);
        this.toolbar.on('change:unit', this.onUnitComboChange, this);
        this.toolbar.on('click:createDataTable', this.onCreateDataTableClick, this);
        this.toolbar.on('click:export', () => new SA.VectorMapExportController(this.model));
    },

    initView() {
        var view = Ext.widget({xtype: 'vector-map-view', model: this.model});

        this.projectView = SA.ProjectView.createHidden(view);

        view.onMove(this.onMove, this);
        view.onMoveEnd(SA.createBuffered(this.onMoveEnd, 100), this);
        view.onWebGLContextLost(this.onWebGLContextLost, this);

        if (!this.model.hasExtent()) {
            this.loadLocationViewport();
        }
    },

    async loadLocationViewport() {
        if (!this.model.hasLocation() && this.model.hasExtent()) {
            return;
        }

        var geographicRelease = this.model.getGeographicRelease(),
            location = SA.data.LocationsCache.normalizeLocation(this.model.getLocation()),
            {locationSeries, radius} = location ?? SA.data.LocationsCache.normalizeLocation(this.model.getCountryModel().getLocationSeries()),
            viewport = await this.viewportsCache.get({geographicRelease, locationSeries, radius});

        if (SA.Json.equal(location, SA.data.LocationsCache.normalizeLocation(this.model.getLocation()))) {
            this.getView().fitExtent(viewport);

            this.model.setExtent(this.getView().getExtent());
            this.model.setZoom(this.getView().getZoom());
        }
    },

    onActive() {
        if (!this.projectView) {
            this.initView();
        }

        SA.ProjectViewToolbar.setToolbar(this.toolbar);
        SA.ProjectView.show(this.projectView);

        this.getView().addDocEventListeners();

        SA.data.BusinessSearches.on('change:name', this.refresh, this);

        this.refresh();
    },

    onAttributeComboChange(attribute) {
        if (this.model.addAttribute(attribute)) {
            this.model.save();

            if (attribute) {
                SA.data.RecentAttributes.add(attribute);
            }
        }
    },

    onCreateDataTableClick() {
        var locations = this.model.getLocations(),
            geographicUnit = this.model.getGeographicUnit(),
            attributes = this.model.getAttributes(),
            censusRelease = this.model.getCensusRelease(),
            ranking = this.model.getProject().addViewWithParams({type: 'ranking', params: {locations, geographicUnit, attributes, censusRelease}});

        SA.AppController.showProjectView(ranking);
    },

    onInactive() {
        SA.data.BusinessSearches.un('change:name', this.refresh, this);

        this.getView().removeDocEventListeners();
    },

    onMove() {
        if (!this.model.hasExtent()) {
            return;
        }

        this.model.setExtent(this.getView().getExtent(), {suppressEvent: true});
        this.model.setZoom(this.getView().getZoom());
    },

    onMoveEnd() {
        if (!this.model.hasExtent()) {
            return;
        }

        this.model.save();

        this.getView().loadLegendMapCenter();

        this.refresh();
    },

    onLocationDropdownChange(location) {
        if (this.model.addLocation(location)) {
            this.model.save();

            if (location) {
                SA.data.RecentLocations.add(location);
            }
        }
    },

    onModelRemove() {
        this.toolbar.destroy();
        this.projectView.destroy();
    },

    onUnitComboChange(unit) {
        this.model.setGeographicUnit(unit);
        this.model.save();
    },

    onWebGLContextLost() {
        this.projectView.destroy();
        this.projectView = null;
    },

    refresh() {
        if (!this.activeState.isActive() || !this.model.hasExtent()) {
            return;
        }

        var modelState = this.model.getState();

        this.toolbar.setModelState(modelState);

        this.getView().refreshLegend();
        this.getView().setModelState(modelState);
    }
});